import { render, staticRenderFns } from "./publish-on-modal.vue?vue&type=template&id=49de67ea"
import script from "./publish-on-modal.vue?vue&type=script&lang=js"
export * from "./publish-on-modal.vue?vue&type=script&lang=js"
import style0 from "./publish-on-modal.vue?vue&type=style&index=0&id=49de67ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports